import ClientAcceptanceNotePanel from './ClientAcceptanceNotePanel.tsx';
import ClientAcceptanceOutcomeRow from './ClientAcceptanceOutcomeRow.tsx';
import { ACCEPTANCE_NO_RESPONSE_SENTENCE } from './clientAcceptanceCopy.ts';

type ClientAcceptanceOutcomePanelProps = React.HTMLAttributes<HTMLDivElement>;

/** Trzy wyjścia z akceptacji i to, co każde robi z paczką. */
const ClientAcceptanceOutcomePanel = (
  props: ClientAcceptanceOutcomePanelProps,
) => (
  <ClientAcceptanceNotePanel
    title="Po decyzji"
    contentClassName="gap-3 pt-3.5"
    {...props}
  >
    <ClientAcceptanceOutcomeRow tone="success" term="Akceptacja">
      wprowadza paczkę: wartości stają się bieżące, raty rosną o dopłatę, paczka
      trafia do historii.
    </ClientAcceptanceOutcomeRow>
    {/* Odrzucenie jest stanem końcowym (`BookingChange.reject`) — paczki nie da
        się poprawić i wysłać drugi raz, nawet gdy komentarz mówi, co poprawić. */}
    <ClientAcceptanceOutcomeRow tone="error" term="Odrzucenie">
      zamyka paczkę bez wprowadzania zmian, z komentarzem zapisującego, jeśli go
      dopisał — widać go w historii zmian. Rezerwacja wraca do edycji, a
      poprawki idą nową paczką.
    </ClientAcceptanceOutcomeRow>
    <ClientAcceptanceOutcomeRow tone="neutral" term="Brak reakcji">
      {ACCEPTANCE_NO_RESPONSE_SENTENCE}
    </ClientAcceptanceOutcomeRow>
  </ClientAcceptanceNotePanel>
);

export default ClientAcceptanceOutcomePanel;
